var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharmDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 415.708,
    height: 481.217,
    viewBox: "0, 0, 415.708, 481.217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-48.146, -15.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.136,15.392 Q266.782,15.392 273.605,22.215 Q280.429,29.039 280.429,39.684 L280.429,315.367 L278.519,373.779 L360.678,283.978 L421.819,223.655 Q425.095,220.38 429.735,218.605 Q434.375,216.831 439.288,216.831 Q449.66,216.831 456.348,223.792 Q463.035,230.752 463.035,240.851 Q463.035,245.764 460.988,250.268 Q458.941,254.772 454.847,259.139 L274.424,439.834 Q270.603,443.928 265.826,446.112 Q261.05,448.296 256.136,448.296 Q250.95,448.296 246.31,446.112 Q241.67,443.928 237.849,439.834 L57.153,259.139 Q53.332,254.772 51.285,250.268 Q49.238,245.764 49.238,240.851 Q49.238,230.752 55.925,223.792 Q62.613,216.831 72.985,216.831 Q77.898,216.831 82.538,218.605 Q87.178,220.38 90.454,223.655 L151.595,283.978 L233.754,374.052 L231.571,315.367 L231.571,39.684 Q231.571,29.039 238.531,22.215 Q245.491,15.392 256.136,15.392 z M71.62,447.75 L439.834,447.75 Q450.479,447.75 457.167,454.574 Q463.854,461.397 463.854,472.043 Q463.854,482.688 457.167,489.648 Q450.479,496.608 439.834,496.608 L71.62,496.608 Q61.248,496.608 54.697,489.648 Q48.146,482.688 48.146,472.043 Q48.146,461.397 54.697,454.574 Q61.248,447.75 71.62,447.75 z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharmDown);
export default __webpack_public_path__ + "static/media/charm-down.aa5c54d1c20da1d3195258dee100d5ae.svg";
export { ForwardRef as ReactComponent };